import CodeEditor from "components/CodeEditor";
import { Copy } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import Card from "ds/components/Card";
import TableBodyRow from "ds/components/Table/Row";
import useCopyToClipboard from "hooks/useCopyToClipboard";

import styles from "./styles.module.css";

type SpaceDetailsPoliciesBodyPreviewProps = {
  body: string;
  columnsCount: number;
  keyboardProps: Record<string, unknown>;
};

const SpaceDetailsPoliciesBodyPreview = ({
  body,
  columnsCount,
  keyboardProps,
}: SpaceDetailsPoliciesBodyPreviewProps) => {
  const copyToClipboard = useCopyToClipboard(body);

  return (
    <TableBodyRow {...keyboardProps}>
      <td colSpan={columnsCount} className={styles.colSpanCell}>
        <Box padding="0 large large large" fullWidth>
          <Card fullWidth fullbleed overflowHidden className={styles.bodyPreview}>
            <ButtonIcon
              size="medium"
              variant="secondary"
              icon={Copy}
              onPress={copyToClipboard}
              className={styles.copyButton}
            >
              Copy
            </ButtonIcon>
            <CodeEditor body={body} readOnly language="rego" autoHeight maxAutoHeight={400} />
          </Card>
        </Box>
      </td>
    </TableBodyRow>
  );
};

export default SpaceDetailsPoliciesBodyPreview;
